import { t } from '../utils/i18n'
import InlineSvg from './InlineSvg'

const HeaderButton = ({ shareUrl, type, currencyCode }) => {
  switch (type) {
    case 'download':
      return (
        <a
          className="velorbis-customizer-header-tool"
          title={t('download_jpg')}
          href={shareUrl}
        >
          <div
            className="velorbis-customizer-header-tool-inner"
            title={t('download_jpg')}
          >
            <InlineSvg src="icons/jpg" title={t('download_jpg')} />
          </div>
        </a>
      )
    case 'pdf': {
      const url = shareUrl.concat(`&currency=${currencyCode}`)
      return (
        <a
          target="_blank"
          rel="noreferrer"
          className="velorbis-customizer-header-tool"
          title={t('download_specifications')}
          href={url}
        >
          <div className="velorbis-customizer-header-tool-inner">
            <InlineSvg src="icons/spcfk" />
          </div>
        </a>
      )
    }
    case 'download-pdf': {
      return (
        <a
          className="velorbis-customizer-header-tool"
          href={shareUrl.replace('bike-image', 'bike-only-pdf')}
          title={t('download_pdf')}
        >
          <div className="velorbis-customizer-header-tool-inner">
            <InlineSvg src="icons/pdf" />
          </div>
        </a>
      )
    }
  }
}

export default HeaderButton
